import { render, staticRenderFns } from "./TiposActividad.vue?vue&type=template&id=48909260&"
import script from "./TiposActividad.vue?vue&type=script&lang=ts&"
export * from "./TiposActividad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports